import * as React from "react";
const SvgCloseCircle = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_5407_36236)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.8334 15.8333L24.1667 24.1667M24.1667 15.8333L15.8334 24.1667",
      stroke: "#121317",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )),
  /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 39, height: 39, rx: 19.5, stroke: "#DEDFE3" }),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_5407_36236" }, /* @__PURE__ */ React.createElement("rect", { width: 40, height: 40, rx: 20, fill: "white" })))
);
export default SvgCloseCircle;
